<template>
  <div id="app">

    <div class="bg-black navbar-dark sticky-top" data-sticky="top">

      <div class="container">
        <nav class="navbar navbar-expand-lg">

          <a class="navbar-brand mx-auto" href="#">
            <img alt="Trackd Music" height="27" src="./assets/logo.png" />
          </a>

          <!--end nav collapse-->
        </nav>
      </div>
      <!--end of container-->
    </div>

    <router-view :key="$route.fullPath" >

        <a href="#">
          <img alt="Trackd Music" height="27" src="./assets/logo.png" />
        </a>

    </router-view>

      <footer class="footer-short">
        <div class="container">
          
          <div class="row mb-3 mt-4">
            <div class="col text-center">
              <small class="mb-3 text-center">{{ new Date().getFullYear() }} Trackd Music &copy; All Rights Reserved</small>
            </div>
            <!--end of col-->
          </div>
          <!--end of row-->
        </div>
        <!--end of container-->
      </footer>

    <b-modal id="modal-center" class="bg-transparent" :hide-header="true" body-class="bg-transparent" :hide-footer="true" :visible="loading" centered>
      
      <template v-slot:default>
        <img alt="Trackd Music" src="./assets/img/custom/trackd-loading.gif" height="60" style="z-index: 4000; opacity: 1;" class=" d-block mx-auto my-5" />
      </template>
      
    </b-modal>

  </div>

</template>

<script>

  export default {
    name: 'app',
    computed: {
      loading() {
        return false
      },
      auth() {
        return this.$store.getters.isAuthenticated
      },
    },
    methods: {
      logoutUser () {
        this.$store.dispatch('logout');
      }
    },
    created() {
      //this.$store.dispatch('autoLogin')
    }
  }
</script>


<style lang="css" scoped>
.modal-content {
  opacity: 0;
}
</style>